import styled, { css } from "styled-components";

const desktopMixin = css`
  & > div {
    display: flex;
    gap: initial;
    align-items: center;

    @media (min-width: 1000px) {
      justify-content: space-between;
    }
  }
`;

export const Container = styled.footer`
  padding: 4em 2em;
  max-width: 1126px;
  margin: 0 auto;

  & > div {
    display: grid;
    padding: 0;
    gap: 1em;
    justify-items: flex-start;
  }

  ${(props) => (props.desktop ? desktopMixin : "")}
`;
